module.exports = __webpack_public_path__ + "static/devonshiresquare-c6fe2b563c42ae1e7d8955026c50eb24.jpg";